const codes = {
  EUR: '€',
  GBP: '£',
  USD: '$',
}

export const currencySymbolFromCode = code => codes[code]

export const moneyString = ({ amount, currencyCode }) => {
  if (!amount && !currencyCode) return ''
  if (!amount) return currencySymbolFromCode(currencyCode)
  if (!currencyCode) return amount

  return `${currencySymbolFromCode(currencyCode)}${amount}`
}
